<template>
  <el-dialog :visible.sync="visible" :title="title" width="1200px" class="check-dialog">
    <el-descriptions>
      <template slot="title">
        <span class="user">{{ checkedDetail.applyInfo.userName }}的申请</span>
        <b class="status"
          :style="{ '--color': ['var(--mainColor)', 'var(--successColor)', 'var(--dangerColor)', 'var(--warningColor)', 'var(--warningColor)', 'var(--dangerColor)'][checkedDetail.applyInfo.approvalStatus - 1] }">{{
            ['审批中',
              '已通过', '未通过', '已撤销 ', '挂起 ', '已结束'][checkedDetail.applyInfo.approvalStatus - 1] }}</b>
      </template>
      <template slot="extra">
        <code>审批编码：{{ checkedDetail.applyInfo.applyNo }}</code>
      </template>
      <el-descriptions-item v-for="item in checkedDetail.applyInfo.formData.detailList" :key="item.fieldId"
        :label="item.fieldTitle">
        {{ item.type === 2 ? item.fieldName : item.fieldValue }}</el-descriptions-item>
    </el-descriptions>
    <el-divider></el-divider>
    <el-timeline>
      <el-timeline-item icon="el-icon-success" color="var(--successColor)">
        <div class="content">
          <span>提交</span>
          <span>{{ checkedDetail.applyInfo.createTime }}</span>
        </div>
        <p>{{ checkedDetail.applyInfo.userName }}</p>
      </el-timeline-item>
      <el-timeline-item v-for="item in checkedDetail.flowRecord.data.flowList" :key="item.taskId"
        :icon="item.finishTime ? item.comment.type == 1 ? 'el-icon-success' : 'el-icon-error' : 'el-icon-question'"
        :color="item.finishTime ? item.comment.type == 1 ? 'var(--successColor)' : 'var(--dangerColor)' : 'var(--warningColor)'">
        <div class="content">
          <span>{{ item.finishTime ? item.comment.type == 1 ? '已审核 / 通过' : '已审核 / 不通过' : '待审核' }}</span>
          <span>{{ item.finishTime }}</span>
        </div>
        <p>{{ item.assigneeName }}</p>
        <p v-if="item.finishTime">审核意见：{{ item.comment.comment || '无' }}</p>
      </el-timeline-item>
    </el-timeline>
    <div class="buttons" v-if="!$parent.select.checked">
      <el-input v-model="comment" placeholder="请输入审核意见"></el-input>
      <el-button type="primary" @click="checkApply('agree')">通过</el-button>
      <el-button type="primary" @click="checkApply('reject')">不通过</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as api from './api'
export default {
  name: 'CheckDialog',
  data() {
    return {
      visible: false,
      title: '',
      checkedDetail: {
        applyInfo: {
          formData: {}
        },
        flowRecord: {
          data: {}
        }
      },
      taskId: '',
      comment: ''
    }
  },
  methods: {
    async checkApply(type) {
      type === 'agree' ? await api.agreeApply({
        taskIdList: [this.taskId],
        comment: this.comment
      }) : await api.rejectApply({
        taskId: this.taskId,
        comment: this.comment
      })
      this.$message.success(type === 'agree' ? '已通过申请' : '已拒绝申请')
      this.$parent.getApplyList()
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.check-dialog {
  .user {
    margin-right: 20px;
    font-weight: bold;
  }

  .status {
    border: 1px solid var(--color);
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 2px;
    color: var(--color)
  }

  code {
    color: #888;
    font-size: 12px;
  }

  .content {
    display: flex;
    justify-content: space-between;

    span:nth-child(1) {
      font-weight: bold;
    }

    span:nth-child(2) {
      color: #999;
    }

    &~p {
      margin-top: 10px;
      color: #999;
    }
  }

  .buttons {
    display: flex;

    .el-input {
      margin-right: 10px;
    }
  }
}
</style>